import { useState } from 'react'
import { useSignIn } from '../hooks/useAuth'

/**
 * Not in the §4 page list, but auth is Phase 0 scope and the farm has to get in
 * somehow. Email and password against Supabase; the API verifies the token.
 */
export function SignIn() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const signIn = useSignIn()

  return (
    <div className="signin">
      <form
        onSubmit={(event) => {
          event.preventDefault()
          signIn.mutate({ email, password })
        }}
      >
        <h2>Sign in</h2>
        <p className="muted">This farm&rsquo;s live records. Sign in to enter or view data.</p>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />

        <button type="submit" disabled={signIn.isPending}>
          {signIn.isPending ? 'Signing in…' : 'Sign in'}
        </button>

        {signIn.isError ? (
          <p role="alert" className="error">
            {signIn.error.message}
          </p>
        ) : null}
      </form>
    </div>
  )
}
